import script from "./CompletionReport-2.vue?vue&type=script&setup=true&lang=ts"
export * from "./CompletionReport-2.vue?vue&type=script&setup=true&lang=ts"

import "./CompletionReport-2.vue?vue&type=style&index=0&id=28b8f6fe&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28b8f6fe"]])

export default __exports__